module.exports = __webpack_public_path__ + "static/media/landingM.340f51fb.png";